var app = angular.module("leonardo");

var TaskDismissDialog = function($scope, ngDialog, NoteService, FormErrorsService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.file = $scope.ngDialogData.file;
  $scope.work_order = $scope.ngDialogData.work_order;
  $scope.data = {};
  $scope.attachments = [];

  $scope.removeAttachment = function(index) {
    $scope.attachments.splice(index, 1);
  };

  $scope.showAttachDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: {task: {}, mode: 'upload'}
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments.push(attachment);
      });
    }, function () {
      return;
    });
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    if ($scope.task) {
      data['attachments'] = [];
      angular.forEach($scope.attachments, function(attachment) {
        data['attachments'].push(attachment.id);
      });
      data['actionitem_set'] = [];
      data['actionitem_set'].push($scope.task.id);
      $scope.task.dismiss().then(function(data_result) {
        $scope.task = $scope.work_order ? angular.copy(data_result) : $scope.task;
        if (!$scope.work_order) {
          $scope.task.status = data_result.status;
        }
        if (data['text'] || (data['attachments'].length > 0)) {
          NoteService.post(data).then(function(note) {
            if (!$scope.work_order) {
              $scope.task.notes.push(note);
            }
            else {
              $scope.task.action_item.notes.push(note);
            }
            $scope.confirm($scope.task);
          });
        }
        else {
          $scope.confirm($scope.task);
        }
      }, function(){
        $scope.confirm($scope.task);
      });
    }
    else if ($scope.file) {
      $scope.file.remove().then(function(data_result) {
        $scope.confirm(data_result);
      }, function(){
        $scope.confirm($scope.file);
      });
    }

  };
};

app.controller('TaskDismissDialog', ['$scope', 'ngDialog', 'NoteService', 'FormErrorsService', TaskDismissDialog]);
